import { PackagesApi } from '@teamjourney/catalogue-client-typescript';
import Cookies from 'js-cookie';
import getConfig from 'next/config';
import { createApiClient } from '../config.api';

const TOKEN_NAME = 'token';
export const V1 = 'v1';
export const V2 = 'v2';

const { CATALOGUE_URL, SERVICE_URL } = getConfig().publicRuntimeConfig;

export const spaPackageApiClient = createApiClient(PackagesApi, 'catalogue', {
  accessToken: Cookies.get(TOKEN_NAME),
  basePath: CATALOGUE_URL ?? `${SERVICE_URL}/catalogue`,
});
